import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { cloneDeep } from 'lodash';


interface subscribersState {
    ridersDataList: {
        actionName: string | null;
        allRowsCounter: number;
        riders: any[];
    }
}
    

const initialState: subscribersState = {
    ridersDataList: {
        actionName: null,
        allRowsCounter: 0,
        riders: [],
    },
}

export const subscribersSlice = createSlice({
    name: 'subscribersSlice',
    initialState,
    reducers: {
        setRidersDataList: (state, action: PayloadAction<any>) => {
            state.ridersDataList = cloneDeep(action.payload);
        },
    },
})
export const { setRidersDataList} = subscribersSlice.actions
export default subscribersSlice.reducer